import { IContributionOverride } from './plan-adoption-form-models';

export interface IPlanLayDcDto {
    plan_effective_date: string;
    latest_amendment_attributes: {
        amendment_date?: string;
        employer_base: string;
        min_scheduled_hours: string;
        employer_match: string;
        employer_override_allowed: string;
    },
    docusign_envelope_id?: string;
    contribution_overrides?: IContributionOverride[];
}

export interface IPlanRsvpDto {
    plan_effective_date: string;
    latest_amendment_attributes: {
        amendment_date?: string;
        employer_base?: string;
        employer_match?: string;
        employer_base_type?: string;
        employer_match_type?: string;
        min_scheduled_hours: string;
        eligible_population: string;
        contribution_type: string;
        employer_override_allowed: string;
    },
    docusign_envelope_id?: string;
    contribution_overrides?: IContributionOverride[];
}

export interface IPlanLayDcAmendDto {
    end_date?: string;
    amendment_date: string;
    employer_base?: string;
    employer_match?: string;    
    min_scheduled_hours: string;        
    employer_override_allowed: string;
    multiple_contribution_schedules?: string;
    plan_id: string | number;
    docusign_envelope_id?: string;
    contribution_overrides?: IContributionOverride[];

}

export interface IPlanRsvpAmendDto {
    end_date?: string;
    amendment_date: string;
    employer_base?: string;
    employer_match?: string;
    employer_base_type?: string;
    employer_match_type?: string;
    min_scheduled_hours: string;
    eligible_population: string;
    contribution_type: string;
    employer_override_allowed: string;
    contribution_overrides?: IContributionOverride[];
    plan_id: string | number;
    docusign_envelope_id?: string;
}

export interface IQccoStatusDto {
    supported_by_church: string;
    offers_services_to_public: string;
    receives_gov_support: string;
}

export interface IPlanSubmitRequest {
    dc_plan?: IPlanLayDcDto;
    rsvp_plan?: IPlanRsvpDto;
    rsvp_amendment?: IPlanRsvpAmendDto;
    dc_amendment?: IPlanLayDcAmendDto;
    qcco_status: IQccoStatusDto;
}

export function GetErrorFromAdoptPlan(planResponse): string[] {

    const itemErrors = [];

    if (planResponse.errors) {
        Object.keys(planResponse.errors).forEach((property) => {
            const error = planResponse.errors[property];

            if (error?.code) {
                itemErrors.push(error);
            }

            if (error && error[0]?.code) {
                itemErrors.push(error[0]);
            }
        });
    }

    if (planResponse.errors?.latest_amendment) {
        Object.keys(planResponse.errors.latest_amendment).forEach((property) => {
            const error = planResponse.errors.latest_amendment[property];

            if (error?.code) {
                itemErrors.push(error);
            }

            if (error && error[0]?.code) {
                itemErrors.push(error[0]);
            }
        });
    }

    if (planResponse.errors?.amendment) {
        Object.keys(planResponse.errors.amendment).forEach((property) => {
            const error = planResponse.errors.amendment[property];

            if (error?.code) {
                itemErrors.push(error);
            }

            if (error && error[0]?.code) {
                itemErrors.push(error[0]);
            }
        });
    }

    return itemErrors.length > 0 ? itemErrors : null;
}

export function mapErrorToPlanAdoptionKey(errorKey: string) {
    switch (errorKey) {
        case 'min_scheduled_hours':
            return 'minimum_scheduleds_hours';
        case 'eligible_population':
            return 'member_type';
        case 'employer_base_type':
            return 'employer_base_contribution_amount_type';
        case 'employer_match_type':
            return 'employer_match_contribution_amount_type';
        case 'contribution_type':
            return 'employer_contribution_status';
        case 'employer_override_allowed':
            return 'allow_multiple_contributions';
        case 'plan_effective_date':
            return 'adoption_date';
        case 'amendment_date':
            return 'adoption_date';
        default:
            return errorKey;
    }
}